import React, {useState, useEffect} from 'react';
import SideMenu from "Components/SideMenu";
import Breadcrumb from "Components/Breadcrumb";
import * as Apis from 'Api';

function Privacy() {
    const [text, setText] = useState('');

    useEffect(() => {
        Apis.getPrivacy().then((resp) => {
            setText(resp.value);
        });
    }, [])

    return (
        <div className={'page-center'}>
            <SideMenu
                title={'약관 정보'}
                menu={[
                    {label: '개인정보처리방침', link: '/privacy', active: true},
                    {label: '이용약관', link: '/usage'},
                ]}
            />
            <div className={'page-content info-container'}>
                <Breadcrumb value={['홈', '약관정보', '개인정보처리방침']}/>
                <div dangerouslySetInnerHTML={{__html: text}} />
            </div>
        </div>
    )
}

export default Privacy;